import Vue from 'vue'
import moment from 'libs/moment'
import { convertToCurrency, formatNumber } from 'utils/functions'
import {
  isValidArray,
  floatToPercent,
  applyCPFNumberMask,
  applyCNPJMask,
  applyPhoneNumberMask,
  convertNumberToStringNotation
} from 'corp-front-vue-commons/src/utils/functions'

Vue.filter('ellipsis', (str = '', chars) => {
  return !str || str.length < chars
    ? str
    : `${str.slice(0, chars - 3)}...`
})

Vue.filter('cnpj', (str = '') => applyCNPJMask(str))

Vue.filter('cpf', (str = '') => applyCPFNumberMask(str))

Vue.filter('currency', (str) => convertToCurrency(str))

Vue.filter('currencyWithoutSymbol', (str) => {
  return convertToCurrency(str).replace(/([^\d,.]+)/, '')
})

Vue.filter('formatNumber', (str) => formatNumber(str))

Vue.filter('convertNumberToStringNotation', (number) => {
  return convertNumberToStringNotation(number)
})

Vue.filter('formatPercentage', (val) => {
  const decimalPlaces = val && Number.isInteger(val) ? 0 : 2
  return val ? floatToPercent(val, decimalPlaces) : '0%'
})

Vue.filter('duration', (start, end) => {
  if (start) {
    const durationStart = moment(start)
    const durationEnd = moment(end)
    const durationDiff = moment.duration(durationEnd.diff(durationStart))
    const minutes = Math.round(durationDiff.asMinutes())
    return minutes
  }
})

Vue.filter('metresToKm', (str) => {
  return str ? `${(str / 1000).toFixed(2)} km` : '-'
})

Vue.filter('getStateAndCountry', (str = '') => {
  const statesRegex = /(AC|AL|AP|AM|BA|CE|DF|ES|GO|MA|MT|MS|MG|PA|PB|PR|PE|PI|RJ|RN|RS|RO|RR|SC|SP|SE|TO)/
  const stateMatch = str.match(statesRegex)
  const state = isValidArray(stateMatch) ? stateMatch[0] : ''
  const countryRegex = /(Brasil)/i
  const countryMatch = str.match(countryRegex)
  const country = isValidArray(countryMatch) ? countryMatch[0] : 'Brasil'
  return state ? `${state} - ${country}` : '-'
})

Vue.filter('durationCalcPerExtensive', (start, end) => {
  if (start && end) {
    const durationDiff = moment.duration(moment(end).diff(moment(start)))
    const durationFormat = moment.utc(durationDiff.asMilliseconds()).format('HH:mm:ss')
    const duration = durationFormat.split(':')
    return duration[0] === '00' ? `${duration[1]} mins` : `${duration[0]}h ${duration[1]}m`
  }
})

Vue.filter('textLowercase', (str = '') => str.toLowerCase())

Vue.filter('phone', (str = '') => applyPhoneNumberMask(str))
